module.exports = __webpack_public_path__ + "static/img/version2.fab5093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version2.png
// module id = 6AQU
// module chunks = 1